import { useOutletContext } from 'react-router';
export function usePageContext() {
    return useOutletContext();
}
